import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faTh,
  faSignOutAlt,
  faDatabase,
  faQrcode,
  faGrinHearts,
  faTable,
  faCog,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/js/dist/collapse";
import { Switch, Route, Redirect } from "react-router-dom";
import api from "../config.json";
import auth from "../httpServices/authService";
import Loading from "../utill/LoadingComponent";
import { ToastContainer, toast } from "react-toastify";
import logo from "../assets/vg.png";
import MainReport from "../Reporting/MainReport";
import { generateExcelFile } from "../utill/download";
import axios from "../httpServices/httpService";
import swal from "sweetalert";
import joi from "joi";
import User from "../Setting/User/User";
import UserTable from "../Setting/User/UserTable";
import UserGroup from "../Setting/UserGroup/UserGroup";
import UserGroupTable from "../Setting/UserGroup/UserGroupTable";
import UserRightTable from "../Setting/UserRights/UserRightTable";
import UserRoleTable from "../Setting/UserRole/UserRoleTable";
import UserRole from "../Setting/UserRole/UserRole";
import ChangePassword from "./ChangePasswordForm";
import TollDataEntry from "../Setting/ToolMaster/TollDataEntry";
import ComponentCodeList from "../Setting/CheckpointConfig/CheckpointConfigList";
import ViewLogsReport from "../Reporting/TracibilityReport/ViewLogs";
import GenerateSticker from "../Setting/GenarateSticker/GenerateSticker";
import CompoundMaster from "../Setting/CompoundMaster/CompoundMaster";
import RMMaster from "../Setting/RawMaterialMaster/RmMaster";
import AssetMaster from "../Setting/AssetMaster/AssetMaster";
import ReservoirMaster from "../Setting/ReservoirMaster/ReservoirMaster";
import RMStorageMaster from "../Setting/RawMateriaStorageMaster/RMStorageMaster";
import InProcessStorageMaster from "../Setting/InprocessStorageMater/InprocessStorageMater";
import MeasurementMaster from "../Setting/MeasurmentMaster/Measurmentmaster";
import VendorMaster from "../Setting/VendorMaster/VendorMaster";
import RMInventory from "../DataEntry/RMInventory";
import RefillLogs from "../DataEntry/RefillLogs";
import ChemicalCheckpoints from "../Reporting/TracibilityReport/ChemicalCheckpoints";
import OilCheckpoints from "../Reporting/TracibilityReport/OilCheckPoints";
import ProcessedData from "../DataEntry/ProcessData";
import Kneading_GreenSheet from "../PrintQueue/Kneading_GreenSheet";
import DisPatch_Section from "../PrintQueue/DisPatch_Section";
import TracibilityReport1 from "../Reporting/TracibilityReport/TracibilityReport1";
import TracibilityReport2 from "../Reporting/TracibilityReport/TracibilityReport2";
import CarbonCheckpoints from "../Reporting/TracibilityReport/CarbonCheckPoints";
import BatchCodeReport from "../Reporting/TracibilityReport/BatchReport";
import AssetbasedProductionLogs from "../Reporting/TracibilityReport/AssetBasedproductionlogs";
import IssueRecords from "../Reporting/TracibilityReport/IssueRecord";
import WarningRegistered from "../Reporting/TracibilityReport/WarningRejesterd";
import OthersCheckpoints from "../Reporting/TracibilityReport/OthersCheckpoints";
import MaterialAvailabilityreport from "../Reporting/TracibilityReport/MaterialAvailabilityReport";

class NavBarUser extends Component {
  state = {
    sidebar: true,
    company: null,
    querySuccess: false,
    userRights: null,
    inspectionArr: [],
    Heading: "",
    chnagePasswordModelState: false,
    chnagePasswordUserData: null,
  };

  componentDidMount() {
    axios
      .get(api.api + "company/" + auth.getCurrentUser().company)
      .then((result) => {
        if (result.data) {
          this.setState({ company: result.data, querySuccess: true });
        } else {
          this.setState({ querySuccess: false });
        }
        this.setState({ querySuccess: false });
      })
      .catch((err) => {
        // this.setState({ querySuccess: false });
        // // Uncomment and configure the toast notification if needed
        toast.error(`${err.message}`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: "red", // Set your desired background color
            color: "white", // Set your desired text color
          },
        });
      });
    this.setState({ querySuccess: true });
    const user = auth.getCurrentUser();
    axios
      .put(api.api + "userrights", { email: user._id })
      .then((result) => {
        console.log(result.data, "rights received");
        if (result.data) {
          this.setState({ userRights: result.data, querySuccess: false });
        } else {
          this.setState({ querySuccess: false });
        }
      })
      .catch((err) => {
        this.setState({ querySuccess: false });
        // swal(`${err}`);
      });
  }

  handleDownloadTableToExcel = (tableId) => {
    generateExcelFile(tableId, new Date(Date.now()));
  };
  handleToggleClick = () => this.setState({ sidebar: !this.state.sidebar });

  handleUserRightsToVisibleOrNot = (dataMemebre, data, perType) => {
    const rights = this.state.userRights;
    let allow = false;
    if (rights != null) {
      console.log(
        dataMemebre,
        data,
        perType,
        rights.StaticDataRights,
        "fsihdfbsdfb"
      );
      rights[dataMemebre].map((one) => {
        if (one.data == data) {
          console.log(
            dataMemebre,
            data,
            one,
            perType,
            rights.StaticDataRights,
            "fsihdfbsdfb"
          );
          allow = one[perType];
        }
      });
    }
    return allow;
  };

  handelSetHeading = (heading) => {
    console.log(heading, "heading from the report");
    this.setState({ Heading: heading });
  };

  handleCloseChnagePassword = () => {
    this.setState({ chnagePasswordModelState: false });
  };

  handleUserChangePassword = () => {
    this.setState({
      chnagePasswordModelState: true,
      chnagePasswordUserData: auth.getCurrentUser(),
    });
  };

  render() {
    const user = auth.getCurrentUser();
    const { handleUserRightsToVisibleOrNot } = this;

    return (
      <>
        <div className="wrapper">
          {this.state.querySuccess ? <Loading /> : ""}
          <ChangePassword
            handleClose={this.handleCloseChnagePassword}
            modelState={this.state.chnagePasswordModelState}
            user={this.state.chnagePasswordUserData}
          />
          <ToastContainer />
          <nav
            id="sidebar"
            style={{ height: "100vh", overflowY: "scroll" }}
            className={this.state.sidebar ? "" : "active"}
          >
            <div className="sidebar-header text-center">
              <img
                src={this.state.company && this.state.company.logo}
                className="avatar"
                style={{
                  borderRadius: 2,
                  width: 150,
                  backgroundColor: "white",
                }}
              />
              <h4 className="text-white fw-bold">
                {""}
                <br />
                <label className="small">
                  {new Object(user).hasOwnProperty("company")
                    ? user.company.toUpperCase()
                    : ""}
                </label>
              </h4>
            </div>
            <ul className="list-unstyled components" id="parent">
              <p style={{ paddingTop: 0, paddingBottom: 0 }}>
                <FontAwesomeIcon icon={faUser} />
                &nbsp;&nbsp;{user ? user.name : ""}
                <br />
                &nbsp;&nbsp;
                <label className="small">{user ? user.userType : ""}</label>
              </p>
              <p style={{ fontSize: 15 }}>
                <a
                  className="btn btn-sm btn-primary"
                  onClick={() => this.handleUserChangePassword()}
                >
                  Change Password
                </a>
                <br></br>
                <a
                  onClick={() => {
                    auth.logout(user.email);
                    window.location = "/";
                  }}
                  className="btn btn-sm btn-primary mt-1"
                >
                  Logout&nbsp;
                  <FontAwesomeIcon icon={faSignOutAlt} />
                </a>
              </p>

              {/* <li className="active">
                <a
                  href="#master"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="reporting"
                  className="collapsed dropdown-toggle text-white"
                >
                  <FontAwesomeIcon icon={faTh} color="white" />
                  &nbsp;Master
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="master"
                  data-parent="#parent"
                > */}

             
              <li>
                <a
                  href="#reporting"
                  data-toggle="collapse"
                  aria-expanded="false"
                  className=" collapsed dropdown-toggle text-white"
                  aria-controls="reporting"
                >
                  <FontAwesomeIcon icon={faTable} color="white" />
                  &nbsp;Reports
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="reporting"
                  data-parent="#parent"
                >
                  {/* {!handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "Downtime",
                    "none"
                  ) ? (
                    <li>
                      <a
                        className="text-white "
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push(
                            "/reporting/BatchCodeReport"
                          );
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                      Batch Code Report
                      </a>
                    </li>
                  ) : (
                    ""
                  )} */}
                  {!handleUserRightsToVisibleOrNot(
                      "ReportRights",
                      "Asset Based Production Logs",
                      "disable"
                    ) ? (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push(
                              "/reporting/AssetbasedProductionLogs"
                            );
                          }}
                        >
                          Asset based Production Logs
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                     {!handleUserRightsToVisibleOrNot(
                      "ReportRights",
                      "Material Availability Report",
                      "disable"
                    ) ? (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push(
                              "/reporting/MaterialAvailabilityreport"
                            );
                          }}
                        >
                          Material Availability Report
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                     {!handleUserRightsToVisibleOrNot(
                      "ReportRights",
                      "Material Issue Record",
                      "disable"
                    ) ? (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/reporting/issueRecords");
                          }}
                        >
                          Material Issue Record
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                  {!handleUserRightsToVisibleOrNot(
                    "ReportRights",
                    "Trace by B/C ; T/N",
                    "disable"
                  ) ? (
                    <li>
                      <a
                        className="text-white "
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push(
                            "/reporting/tracibility_report1"
                          );
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Trace by B/C ; T/N
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {!handleUserRightsToVisibleOrNot(
                    "ReportRights",
                    "Trace by RM",
                    "disable"
                  ) ? (
                    <li>
                      <a
                        className="text-white "
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push(
                            "/reporting/tracibility_report2"
                          );
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Trace by RM
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  <li className="active">
                    {/* <a
                  href="#live"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-controls="reporting"
                  className="collapsed dropdown-toggle text-white"
                >
                  <FontAwesomeIcon icon={faTh} color="white" />
                  &nbsp;View Logs
                </a> */}

                    {/* <ul
                  className="collapse list-unstyled"
                  id="live"
                  data-parent="#parent"
                > */}

                    {!handleUserRightsToVisibleOrNot(
                      "ReportRights",
                      "Traceability Logs",
                      "disable"
                    ) ? (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push("/view_logs");
                          }}
                        >
                          Traceability Logs
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                    
                   
                    {!handleUserRightsToVisibleOrNot(
                      "ReportRights",
                      "Warnings Registered",
                      "disable"
                    ) ? (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push(
                              "/reporting/WarningRegistered"
                            );
                          }}
                        >
                          Warnings Registered
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                     
                     
                   
                  </li>
                  {!handleUserRightsToVisibleOrNot(
                    "ReportRights",
                    "Chemical Checkpoints",
                    "disable"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push(
                            "/reporting/ChemicalCheckpoints"
                          );
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Chemical Checkpoints Logs{" "}
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {!handleUserRightsToVisibleOrNot(
                    "ReportRights",
                    "Carbon Checkpoints",
                    "disable"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push(
                            "/reporting/CarbonCheckpoints"
                          );
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Carbon Checkpoints Logs{" "}
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {!handleUserRightsToVisibleOrNot(
                    "ReportRights",
                    "Oil Checkpoints",
                    "disable"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/reporting/OilCheckpoints");
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Oil Checkpoints Logs{" "}
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  
 {!handleUserRightsToVisibleOrNot(
                      "ReportRights",
                      "Other Checkpoints",
                      "disable"
                    ) ? (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push(
                              "/reporting/OthersCheckpoints"
                            );
                          }}
                        >
                          Others Checkpoint Logs
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                  {/* {!handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "JobSelection",
                    "none"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/dataentry/ProcessedData");
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Processed Data{" "}
                      </a>
                    </li>
                  ) : (
                    ""
                  )} */}
                </ul>
              </li>
              <li>
                <a
                  href="#dataentry"
                  data-toggle="collapse"
                  aria-expanded="false"
                  className=" collapsed dropdown-toggle text-white"
                  aria-controls="dataentry"
                >
                  <FontAwesomeIcon icon={faDatabase} color="white" />
                  &nbsp;Inventory Update
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="dataentry"
                  data-parent="#parent"
                >
                  {!handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "RM Inventory",
                    "none"
                  ) ? (
                    <li>
                      <a
                        className="text-white "
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/dataentry/RMInventory");
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Add RM Inventory
                      </a>
                    </li>
                  ) : (
                    ""
                  )}

                  {!handleUserRightsToVisibleOrNot(
                    "DynamicDataRights",
                    "Refill Logs",
                    "none"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/dataentry/RefillLogs");
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Refill Reservoir{" "}
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                   {handleUserRightsToVisibleOrNot(
                "DynamicDataRights",
                "Generate Traceability Sticker",
                "read"
              ) && (
                <li>
                  <a
                    className="text-white"
                    href="#"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.props.history.push("/Generate_sticker");
                    }}
                  >
                    Generate Traceability Sticker
                  </a>
                </li>
              )}
                </ul>
              </li>
              <li>
                <a
                  href="#Printqueue"
                  data-toggle="collapse"
                  aria-expanded="false"
                  className=" collapsed dropdown-toggle text-white"
                  aria-controls="Printqueue"
                >
                  <FontAwesomeIcon icon={faQrcode} color="white" />
                  &nbsp;Print QR Stickers
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="Printqueue"
                  data-parent="#parent"
                >
                  {!handleUserRightsToVisibleOrNot(
                    "PrintQRStickers",
                    "Green Sheet (QR)",
                    "disable"
                  ) ? (
                    <li>
                      <a
                        className="text-white "
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push(
                            "/qrCode_queue/kneading_greensheet"
                          );
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Green Sheet 
                      </a>
                    </li>
                  ) : (
                    ""
                  )}

                  {!handleUserRightsToVisibleOrNot(
                    "PrintQRStickers",
                    "Activated Sheet (QR)",
                    "disable"
                  ) ? (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push(
                            "/qrCode_queue/DisPatch_sticker"
                          );
                          this.setState({
                            activityDashboardState: false,
                            andonDashboardState: false,
                            cardDashboardState: false,
                            macStateDashboardState: false,
                          });
                        }}
                      >
                        Activation Sticker
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </li>

              <li>
                <a
                  href="#settings"
                  data-toggle="collapse"
                  aria-expanded="false"
                  className=" collapsed dropdown-toggle text-white"
                  aria-controls="settings"
                >
                  <FontAwesomeIcon icon={faCog} color="white" />
                  &nbsp;Master Data
                </a>
                <ul
                  className="collapse list-unstyled"
                  id="settings"
                  data-parent="#parent"
                >
                    {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "Asset Master",
                    "read"
                  ) && (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/AssetMaster");
                        }}
                      >
                        Asset Master
                      </a>
                    </li>
                  )}
                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "Compound Code Master",
                    "read"
                  ) && (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/CompoundMaster");
                        }}
                      >
                        Compound Code Master
                      </a>
                    </li>
                  )}
                   {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "Inprocess Storage Master",
                    "read"
                  ) && (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/InProcessStorageMaster");
                        }}
                      >
                        Inprocess Storage Master
                      </a>
                    </li>
                  )}
                   {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "Measurement Unit",
                    "read"
                  ) && (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/MeasurementMaster");
                        }}
                      >
                        Measurment Unit
                      </a>
                    </li>
                  )}
  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "RM Master",
                    "read"
                  ) && (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/RMMaster");
                        }}
                      >
                        RM Master
                      </a>
                    </li>
                  )}
                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "Reservoir Master",
                    "read"
                  ) && (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/ReservoirMaster");
                        }}
                      >
                        Reservoir Master
                      </a>
                    </li>
                  )}
                
                 
                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "RM Storage Master",
                    "read"
                  ) && (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/RMStorageMaster");
                        }}
                      >
                        RM Storage Master
                      </a>
                    </li>
                  )}
                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "Tool Master",
                    "read"
                  ) && (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/tool_master");
                        }}
                      >
                        Tool Master
                      </a>
                    </li>
                  )}

                  {/* {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "ToolMaster",
                    "read"
                  ) && (
                      <li>
                        <a
                          className="text-white"
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push(
                              "/CompoundMaster"
                            );
                          }}
                        >
                       Compound Master
                        </a>
                      </li>
                    )} */}
                

                 
                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "Vendor Master",
                    "read"
                  ) && (
                    <li>
                      <a
                        className="text-white"
                        href="#"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/VendorMaster");
                        }}
                      >
                        Vendor Master
                      </a>
                    </li>
                  )}

                  {/* <li data-parent="#user">
                            <a
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.props.history.push(
                                  "/setting/usergroup/list"
                                );
                                this.setState({
                                  navSelected: "/setting/usergroup/list",
                                  cardDashboardState: false,
                                  andonDashboardState: false,
                                  macStateDashboardState: false,
                                  activityDashboardState: false,
                                });
                              }}
                            >
                              User Group
                            </a>
                          </li> */}

                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "User Rights",
                    "read"
                  ) && (
                    <li>
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/setting/userrights/list");
                          this.setState({
                            navSelected: "/setting/userrights/list",
                            cardDashboardState: false,
                            andonDashboardState: false,
                            macStateDashboardState: false,
                            activityDashboardState: false,
                          });
                        }}
                      >
                        User Rights
                      </a>
                    </li>
                  )}
                  {handleUserRightsToVisibleOrNot(
                    "StaticDataRights",
                    "User Master",
                    "read"
                  ) && (
                    <li>
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.props.history.push("/setting/user/list");
                          this.setState({
                            navSelected: "/setting/user/list",
                            cardDashboardState: false,
                            andonDashboardState: false,
                            macStateDashboardState: false,
                            activityDashboardState: false,
                          });
                        }}
                      >
                        User
                      </a>
                    </li>
                  )}
                </ul>
              </li>
              {/* </ul>
              </li> */}
            </ul>
            <div className="mt-5 text-center">
              <p className="small mb-0">
                Version:{api.UIVersion}/{this.state.version}
              </p>
              <p className="small mb-0">&copy; Copyright 2021 Leafnet</p>
              <p className="small">
                Powered By{" "}
                <a
                  title="Driti Tech."
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://drititech.com/"
                >
                  : Driti Technologies LLP.
                </a>
              </p>
            </div>
          </nav>
          <div id="content" style={{ padding: 0 }}>
            <nav
              className="d-flex w-100 navbar navbar-expand-lg mb-1 py-0"
              style={{ padding: 0 }}
            >
              <div className="container-fluid px-1 w-100">
                <div
                  // style={{ width: "10%" }}
                  className=" d-flex justify-content-between"
                >
                  <div className="">
                    <input
                      id="checkbox"
                      type="checkbox"
                      onClick={this.handleToggleClick}
                    />
                    <label className="toggle btn-info m-0" htmlFor="checkbox">
                      <div id="bar1" className="bars"></div>
                      <div id="bar2" className="bars"></div>
                      <div id="bar3" className="bars"></div>
                    </label>
                  </div>
                </div>
                <div style={{ width: "100%" }} className="text-center">
                  <div className="text-start text-center text-black  fs-4 fw-medium text-nowrap">
                    {this.state.Heading}
                  </div>
                </div>
              </div>
            </nav>

            <main
              style={{ height: "95vh"
                , overflowY: "scroll", 
                overflowX:"hidden"
              }
              }
              className="mx-1 "
            >
              <Switch>
                <Route
                  path="/"
                  exact
                  render={(props) => (
                    <ViewLogsReport
                      {...props}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/view_logs"
                  exact
                  render={(props) => (
                    <ViewLogsReport
                      {...props}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/tool_master"
                  render={(props) => (
                    <TollDataEntry
                      {...props}
                      RightName="Tool Master"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/Generate_sticker"
                  render={(props) => (
                    <GenerateSticker
                      {...props}
                      RightName="Generate Traceability Sticker"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/setting/component_code/list"
                  render={(props) => (
                    <ComponentCodeList
                      {...props}
                      RightName="CompoundCodeMaster"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/setting/user/add"
                  render={(props) => (
                    <User
                      {...props}
                      RightName={"User Master"}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      user={user}
                    />
                  )}
                />
                <Route
                  path="/setting/user/list"
                  render={(props) => (
                    <UserTable
                      {...props}
                      user={user}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/setting/usergroup/add"
                  render={(props) => (
                    <UserGroup
                      {...props}
                      RightName={"User Master"}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/setting/userrole/list"
                  render={(props) => (
                    <UserRoleTable
                      {...props}
                      RightName={"User Master"}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/setting/userrole/add"
                  render={(props) => (
                    <UserRole
                      {...props}
                      RightName={"User Master"}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                {/* <Route
                  path="/setting/usergroup/list"
                  render={(props) => (
                    <UserGroupTable
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                /> */}

                <Route
                  path="/setting/userrights/list"
                  render={(props) => (
                    <UserRightTable
                      {...props}
                      userRights={this.state.userRights}
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                      user={user}
                    />
                  )}
                />

                <Route
                  path="/CompoundMaster"
                  render={(props) => (
                    <CompoundMaster
                      {...props}
                      RightName="Compound Code Master"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/RMMaster"
                  render={(props) => (
                    <RMMaster
                      {...props}
                      RightName="RM Master"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/AssetMaster"
                  render={(props) => (
                    <AssetMaster
                      {...props}
                      RightName="Asset Master"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/ReservoirMaster"
                  render={(props) => (
                    <ReservoirMaster
                      {...props}
                      RightName="Reservoir Master"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/RMStorageMaster"
                  render={(props) => (
                    <RMStorageMaster
                      {...props}
                      RightName="RM Storage Master"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/InProcessStorageMaster"
                  render={(props) => (
                    <InProcessStorageMaster
                      {...props}
                      RightName="Inprocess Storage Master"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/MeasurementMaster"
                  render={(props) => (
                    <MeasurementMaster
                      {...props}
                      RightName="Measurement Unit"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/VendorMaster"
                  render={(props) => (
                    <VendorMaster
                      {...props}
                      RightName="Vendor Master"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/dataentry/RMInventory"
                  render={(props) => (
                    <RMInventory
                      {...props}
                      RightName="RM Inventory"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/dataentry/RefillLogs"
                  render={(props) => (
                    <RefillLogs
                      {...props}
                      RightName="Refill Logs"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/reporting/ChemicalCheckpoints"
                  render={(props) => (
                    <ChemicalCheckpoints
                      {...props}
                      RightName="Chemical Checkpoints"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/reporting/OilCheckpoints"
                  render={(props) => (
                    <OilCheckpoints
                      {...props}
                      RightName="Oil Checkpoints"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/reporting/CarbonCheckpoints"
                  render={(props) => (
                    <CarbonCheckpoints
                      {...props}
                      RightName="Carbon Checkpoints"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/dataentry/ProcessedData"
                  render={(props) => (
                    <ProcessedData
                      {...props}
                      RightName="Tool Master"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/qrCode_queue/kneading_greensheet"
                  render={(props) => (
                    <Kneading_GreenSheet
                      {...props}
                      RightName="Green Sheet (QR)"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/qrCode_queue/DisPatch_sticker"
                  render={(props) => (
                    <DisPatch_Section
                      {...props}
                      RightName="Activated Sheet (QR)"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/reporting/BatchCodeReport"
                  render={(props) => (
                    <BatchCodeReport
                      {...props}
                      RightName="Dispatch"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/reporting/tracibility_report1"
                  render={(props) => (
                    <TracibilityReport1
                      {...props}
                      RightName="Trace by B/C ; T/N"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/reporting/tracibility_report2"
                  render={(props) => (
                    <TracibilityReport2
                      {...props}
                      RightName="Trace by RM"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/reporting/AssetbasedProductionLogs"
                  render={(props) => (
                    <AssetbasedProductionLogs
                      {...props}
                      RightName="Asset Based Production Logs"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/reporting/issueRecords"
                  render={(props) => (
                    <IssueRecords
                      {...props}
                      RightName="Material Issue Record"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/reporting/WarningRegistered"
                  render={(props) => (
                    <WarningRegistered
                      {...props}
                      RightName="Warnings Registered"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                <Route
                  path="/reporting/OthersCheckpoints"
                  render={(props) => (
                    <OthersCheckpoints
                      {...props}
                      RightName="Other Checkpoints"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />

                <Route
                  path="/reporting/MaterialAvailabilityreport"
                  render={(props) => (
                    <MaterialAvailabilityreport
                      {...props}
                      RightName="Material Availability Report"
                      getRightsForAccess={handleUserRightsToVisibleOrNot}
                      Heading={this.handelSetHeading}
                    />
                  )}
                />
                
              </Switch>
            </main>
          </div>
        </div>
      </>
    );
  }
}

export default NavBarUser;
